const ALLOWED_VALUATION_AREAS = [
  '1000', '1086', '1079', '1073', '1091', '1002', '1088', '1075', '1083', '7000',
  '1100', '1085', '1078', '1093', '1096', '1076', '1084', '1097', '1094', '1082',
  '1071', '1089', '1081', '1074', '1072', '1099', '1080', '1098', '1087'
]

function validateStockDataOptions (options) {
  const errors = []
  const { page, size, valuationArea, program, maxConcurrency } = options

  if (page !== undefined) {
    if (!Number.isInteger(page) || page < 0) {
      errors.push('page must be integer >= 0')
    }
  }

  if (size !== undefined) {
    if (!Number.isInteger(size) || size < 1 || size > 5000) {
      errors.push('size must be integer between 1-5000')
    }
  }

  if (maxConcurrency !== undefined) {
    if (!Number.isInteger(maxConcurrency) || maxConcurrency < 1 || maxConcurrency > 3) {
      errors.push('maxConcurrency must be integer between 1-3')
    }
  }

  if (valuationArea !== undefined) {
    if (typeof valuationArea !== 'string') {
      errors.push('valuationArea must be string')
    } else if (!ALLOWED_VALUATION_AREAS.includes(valuationArea)) {
      errors.push(`valuationArea '${valuationArea}' is invalid`)
    }
  }

  if (program !== undefined) {
    if (typeof program !== 'string') {
      errors.push('program must be string')
    }
  }

  if (errors.length > 0) {
    const error = new Error(`RMS validation failed: ${errors.join('; ')}`)
    throw error
  }
}

module.exports = { validateStockDataOptions }
